import { useMotion } from '../lib/motion';

const facts = [
  { value: "5,0", count: 5, decimals: 1, label: "nota no Google" },
  { value: "41", count: 41, label: "avaliações de clientes" },
  { value: "31", count: 31, label: "estilos na agenda" },
  { value: "Seg a Sáb", label: "das 7h30 às 17h30" },
];

export default function Proof() {
  const scope = useMotion();

  return (
    <section ref={scope} aria-label="Números do salão" className="border-y border-rule">
      <dl className="max-w-7xl mx-auto px-4 md:px-8 py-8 grid grid-cols-2 md:grid-cols-4 gap-y-6 gap-x-4">
        {facts.map((fact, i) => (
          <div key={fact.label} data-rise={i * 0.08} className="flex flex-col-reverse">
            <dt className="text-sm text-soft mt-1">{fact.label}</dt>
            <dd
              className="text-3xl md:text-4xl font-extrabold tracking-tight text-ink tabular-nums"
              data-count={fact.count}
              data-decimals={fact.decimals}
            >
              {fact.value}
            </dd>
          </div>
        ))}
      </dl>
    </section>
  );
}
